import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/[locale]/projects/page.tsx");
